import { useAppText } from "src/commun/composants/AppText";

const useTranslateErrorMessage = () => {
  const { tString } = useAppText();

  const translateErrorMessage = (error: string/*error: GenericApiError*/) => {
      return tString(error);
  };

  return {
    translateErrorMessage,
  };
};

export default useTranslateErrorMessage;
